import React, { useState } from "react";
import copy from 'copy-to-clipboard';

export default function UseUsers() {
    const [data, setData] = useState(
        [
            {
                userName: 'Adminomar',
                password: '1234567891234567891',
                showPassword: false,
                id: 1,
            },
            {
                userName: 'Adminomar',
                password: '1234567891234567891',
                showPassword: false,
                id: 2,
            },
            {
                userName: 'Adminomar',
                password: '1234567891234567891',
                showPassword: false,
                id: 3,
            },
        ]
    )
    const [searchVal, setSearchVal] = useState('');
    const [copiedAlert, setCopiedAlert] = useState(false);
    const showPasswordHandler = (item) => {
        const newData = {
            userName: item?.userName,
            password: item?.password,
            showPassword: !item?.showPassword,
            id: item?.id,
        };
        const newDataArray = data?.map((user) => {
            if (user?.id == item?.id) {
                return newData;
            }
            else {
                return user;
            }
        })
        setData(newDataArray);
    };
    const copyHandler = (password) => {
        copy(password);
        setCopiedAlert(true);
        setTimeout(() => {
            setCopiedAlert(false);
        }, 3000)
    };
    const securePasswordHandler = (password) => {
        const star = '*';
        const length = star.repeat(password.length);
        return length;
    }
    return [{ data, searchVal, setSearchVal, copyHandler, copiedAlert, showPasswordHandler,securePasswordHandler }]
}
